// Types
export enum ArticleType {
  STUDIO = 'STUDIO',
  EPISODE = 'EPISODE',
}

export enum EnthuseObjectTypes {
  STUDIO = 'STUDIO',
  COMMENT = 'COMMENT',
  EPISODE = 'EPISODE',
}

export enum FollowTypes {
  USER = 'USER',
}

// Actions
export enum FollowActions {
  FOLLOW = 'FOLLOW',
  UNFOLLOW = 'UNFOLLOW',
}

export enum VoteActions {
  UPVOTE = 'UPVOTE',
  DOWNVOTE = 'DOWNVOTE',
}

export type CommentAction = 'COMMENT' | 'STUDIO' | 'EPISODE';
